module.exports = {"svg":{"$":{"t":"1524471362915","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1915","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"48","height":"48"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z","p-id":"1916"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/close.svg
// module id = jWHt
// module chunks = 37